import { useI18n } from '#/i18n/hooks/useI18n';
import { I18nLocale } from '#/i18n/types/I18nLocale';
import { LocaleFacet } from '#/modules/search/components/Facet/LocaleFacet';
import { OrgAreasOfFocusFacet } from '#/modules/search/components/Facet/OrgAreasOfFocusFacet';
import { OrgTypeFacet } from '#/modules/search/components/Facet/OrgTypeFacet';
import { RadiusFacet } from '#/modules/search/components/Facet/RadiusFacet';
import { SearchRefinements } from '#/modules/search/components/Refinements/SearchRefinements';

export function SearchOrgRefinements() {
  const { locale } = useI18n();

  return (
    <SearchRefinements
      listingType="JOB"
      renderFacets={({ variant }) => {
        switch (locale) {
          case I18nLocale.EN:
            return (
              <>
                <OrgAreasOfFocusFacet variant={variant} />
                <OrgTypeFacet variant={variant} />
                <LocaleFacet variant={variant} />
                <RadiusFacet variant={variant} />
              </>
            );

          case I18nLocale.ES:
            return (
              <>
                <LocaleFacet variant={variant} />
                <OrgAreasOfFocusFacet variant={variant} />
                <OrgTypeFacet variant={variant} />
                <RadiusFacet variant={variant} />
              </>
            );

          case I18nLocale.PT:
            return (
              <>
                <LocaleFacet variant={variant} />
                <OrgAreasOfFocusFacet variant={variant} />
                <OrgTypeFacet variant={variant} />
                <RadiusFacet variant={variant} />
              </>
            );
        }
      }}
    />
  );
}
